<template>
  <div class="cards__list">
    <div v-for="workout in workoutsOfDay" :key="workout.title" class="card">
      <div class="img">
        <img :src="`${contentUrl}${workout.baseUrl}/cover.png`" alt="">
      </div>

      <div class="card__content">
        <h3>{{workout.title}}</h3>
        <p>
          {{workout.exercises.length}} {{$t("profile.exercises.exercisesNum")}}
        </p>

        <div class="card__action" @click="handleCardAction(workout)">
          {{ $t("profile.home.start") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import workouts from "./data/workouts.en.json";

export default {
  name: "day-workouts",

  inject: ['contentUrl'],

  props: ["date"],

  data() {
    return {
      workoutsOfDay: [],
      currentDate: new Date(this.date),
      workoutsList: workouts,
    };
  },

  async created() {
    try {
      const localeData = await import(`../components/data/workouts.${this.$i18n.locale}.json`);
      this.workoutsList = localeData.default;
    } catch (e) {
      console.log(e);
    }
    this.workoutsOfDay = this.getWorkoutsOfDay();
  },

  watch: {
    date(value) {
      this.currentDate = new Date(value);
      this.workoutsOfDay = this.getWorkoutsOfDay();
    },
  },

  methods: {
    handleCardAction(workout) {
      if (workout.eye) {
        this.$router.push(`/profile/exercises?q=1`);
      } else {
        this.$router.push(`/profile/exercises/${workout.id}`);
      }
    },
    getWorkoutsOfDay() {
      const day = this.currentDate.getDate();
      const workoutsList = Object.keys(this.workoutsList);

      const eyeExercises = Object.values(this.workoutsList).find(w => w.eye);
      if (day > workoutsList.length - 2) {
        return [this.workoutsList[workoutsList[day % (workoutsList.length - 1)]], eyeExercises];
      } else {
        return [this.workoutsList[workoutsList[day]], eyeExercises];
      }
    },
  },
}
</script>
